import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgsTopic4 } from "../../../assets/imgs/Tema4";
import { ModalInfo } from "../../../components/common/ModalInfo";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	dialogTwo: 3,
	activityInfo: 4,
	modalOne: 5,
	modalTwo: 6,
	modalThree: 7,
	modalFour: 8,
	win: 13,
	touchActivity: 20,
}

export const Tema5SubtopicThreeActivityOne = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema5.activities.subtema3], 1);
	useEffect(() => {
		if (loaded) {
			console.log("tema 5 subtema3 activity 1");
			ObserverEmitter.emit(EVENTS.tema5.subtopicThree.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.tema5.subtopicTwo.activityOne.nextUI, (nextUI) => {
		const modalSteps = {
			1: steps.modalOne,
			2: steps.modalTwo,
			3: steps.modalThree,
		}
		setUiToShow(modalSteps[nextUI]);
	})
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act1_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{[2, 3, 4, 13].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema5.subtopicThree.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 1: Remesas observaciones." />
					<DialogBarNew
						dialog={
							'¡Bien! Hablaremos ahora sobre las Remesas. Te preguntarás ¿Qué son las remesas?'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 3: Remesas"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub03.sub3_act1_a02)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							"Las remesas son envíos de dinero, principalmente de Estados Unidos a México. ¡Tomemos en cuenta lo siguiente!"
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.activityInfo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.activityInfo && (
				<>
					<PanelInstrucionHands
						text="Explora tocando los objetos iluminadas."
						action={() => {
							setUiToShow(steps.touchActivity);
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.showOrHideModels, true)
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.touchObject, 1)
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.amplifyDesk)
						}}
						img={imgsTopic4.infoSub2Act2}
					/>
				</>
			)}
			{uiToShow === steps.modalOne && (
				<>
					<ModalInfo
						title="Referencia"
						description='El Cliente debe presentar el "Número de referencia (son de 10 a 12 dígitos)", y una identificación oficial "vigente".'
						action={() => {
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.touchObject, 2)
							setUiToShow(steps.touchActivity);
						}}
					></ModalInfo>
				</>
			)}
			{uiToShow === steps.modalTwo && (
				<>
					<ModalInfo
						title="Identificación oficial"
						action={() => {
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.touchObject, 3)
							setUiToShow(steps.touchActivity);
						}}
					>
						<p>INE/IFE</p>
						<p>Pasaporte</p>
						<p>Cedula Profesional</p>
						<p>Credencial Consular</p>
						<p>Cartilla Militar</p>
					</ModalInfo>
				</>
			)}
			{uiToShow === steps.modalThree && (
				<>
					<ModalInfo
						title="Monto máximo"
						description='"El monto máximo de cobro es de $3,00 pesos". Para retiros de efectivo mayores a lo indicado, el cliente debe acudir a un establecimiento de la compañía emisora.'
						action={() => {
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.showOrHideModels, false)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
							setUiToShow(steps.win);
						}}
					></ModalInfo>
				</>
			)}
			{uiToShow === steps.touchActivity && (
				<>
					<BarStatusActivies activities={tasksList} />
				</>
			)}
			{uiToShow === steps.win && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={0}
						dialogModal="¡Excelente! Ahora ya conoces algunas observaciones para el retiro de remesas."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema5.activities.subtema3,
								})
							);
							navigation("/home5/tema5/subtema3/activityTwo");
						}}
					/>
				</>
			)}

		</>

	)
}